import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex-container-col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_k_input = _resolveComponent("k-input")!
  const _component_k_text = _resolveComponent("k-text")!
  const _component_error = _resolveComponent("error")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.height)
      ? (_openBlock(), _createBlock(_component_k_input, {
          key: 0,
          id: _ctx.id,
          value: _ctx.modelValue,
          placeholder: _ctx.computedPlaceholder,
          label: _ctx.computedLabel,
          disabled: _ctx.disabled,
          "show-validation-icon": _ctx.showValidState && !_ctx.showError,
          onInput: _ctx.onChange
        }, null, 8, ["id", "value", "placeholder", "label", "disabled", "show-validation-icon", "onInput"]))
      : (_openBlock(), _createBlock(_component_k_text, {
          key: 1,
          id: _ctx.id,
          style: _normalizeStyle(_ctx.heightStyle),
          value: _ctx.modelValue,
          placeholder: _ctx.computedPlaceholder,
          disabled: _ctx.disabled,
          "show-validation-icon": _ctx.showValidState && !_ctx.showError,
          onInput: _ctx.onChange
        }, null, 8, ["id", "style", "value", "placeholder", "disabled", "show-validation-icon", "onInput"])),
    _withDirectives(_createVNode(_component_error, { id: _ctx.errorId }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.errorMessage), 1)
      ]),
      _: 1
    }, 8, ["id"]), [
      [_vShow, _ctx.showError]
    ])
  ]))
}